const footerStrings = {
    contact: "Contacto",
    info: "Información",
    other: "Otros",
    address: "Dirección",
    phoneNumber: "Teléfono",
    menu: "Menú",
    termsOfService: "Términos",
    privacyPolicy: "Privacidad",
    copywrite: "© 2025 por WebLords LLC | Creado por Code Decoded"
};

export default footerStrings;